module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/katie-morath-07c381a6a5acdf670cb43e57d31183d8.jpg";